import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  fetchPublisherEmergencyReportByPublisherId,
  PublisherEmergencyReportFetched,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useFetchPublisherEmergencyReportByPublisherId = (
  publisherId: number,
  options: Omit<
    UseQueryOptions<PublisherEmergencyReportFetched, unknown>,
    'queryKey'
  > = {}
) =>
  useQuery({
    queryFn: () =>
      extractData(
        fetchPublisherEmergencyReportByPublisherId({ path: { publisherId } })
      ),
    retry: false,
    ...options,
    queryKey: ['emergencyMode', 'publisher', publisherId],
  });
